import { render, staticRenderFns } from "./serviceProviderList.vue?vue&type=template&id=7b40c40b&scoped=true&"
import script from "./serviceProviderList.vue?vue&type=script&lang=js&"
export * from "./serviceProviderList.vue?vue&type=script&lang=js&"
import style0 from "./serviceProviderList.vue?vue&type=style&index=0&id=7b40c40b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b40c40b",
  null
  
)

export default component.exports